/*
* Copyright © 2019 Insticator, Inc. All Rights Reserved.
*
* CONFIDENTIALITY NOTICE: THIS SOFTWARE CONTAINS CONFIDENTIAL INFORMATION OF
* INSTICATOR, INC. USE, DISCLOSURE OR REPRODUCTION IS PROHIBITED WITHOUT THE PRIOR
* EXPRESS WRITTEN PERMISSION OF INSTICATOR, INC.
*/

/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// SET STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
    storyurl: {
        position: 'absolute',
        zIndex: 2,
        width: 'fit-content',
        fontSize: pxToEm(12),
        '& .storylink': {
            display: 'flex',
            alignItems: 'center',
            color: '#fff',
            fontWeight: 'bold',
            '& .linktext': {
                textDecoration: 'underline'
            },
            '& i': {
              marginLeft: pxToEm(6),
              lineHeight: 'inherit'
            },
            '& path': {
                fill: '#fff'
            },  
        },
        //animation
        opacity: '0',
        animationName: 'fadeInLeft',
        animationDelay: '.2s',
        animationDuration: '.2s',
        animationFillMode: 'forwards',
    },
    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [mediaQuery.medium]: {
        storyurl: {
            fontSize: pxToEm(14),
            '& .storylink':{
                textDecoration: 'none',
                '& .linktext': {
                    textDecoration: 'none',
                    '&:hover': {
                        textDecoration: 'underline'
                    }
                }
            },
            '& .fa-external-link-alt': {
                marginLeft: pxToEm(6),
                fontSize: pxToEm(15),
                lineHeight: 'inherit'
            }
        }
    },
    [mediaQuery.wide]: {
        storyurl: {
            fontSize: pxToEm(14),
            '& .storylink':{
                textDecoration: 'none',
                '& .linktext': {
                    textDecoration: 'none',
                    '&:hover': {
                        textDecoration: 'underline'
                    }
                }
            },
            '& .fa-external-link-alt': {
                marginLeft: pxToEm(6),
                fontSize: pxToEm(15),
                lineHeight: 'inherit'
            }
        }
    }
};